
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[postSlug]",
      function () {
        return require("private-next-pages/blog/[postSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[postSlug]"])
      });
    }
  